import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from '../redux/actions/actions';

const initialState = {
  user: {
    user: '',
    password: '',
  },
  remember: false,
  language: 'es',
  inputType: 'password',
  showPassIcon: 'fa fa-eye-slash',
  emptyField: {
    user: {
      class: '',
      childStyle: {},
    },
    password: {
      class: '',
      childStyle: {},
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export const useLogin = (initialSatateProps = initialState) => {
  const [loginState, setLoginState] = useState(initialSatateProps); // initialState
  const dispatch = useDispatch();

  const triggerLogin = async () => {
    // const { user } = initialSatateProps;
    // Saga modificara el store global y actualizara el store
    // para mas detalles ver  yield put(loginSuccess(true));
    // eslint-disable-next-line no-use-before-define
    const setEmptyField = setEmptyFieldStyles(loginState.user);
    // setState({setEmptyField});
    setLoginState({
      ...loginState,
      emptyField: setEmptyField,
    });
    const regex = /^[a-zA-Z0-9]+$/;
    if(regex.test(loginState.user.user) && !/\s/.test(loginState.user.password)){
      if (loginState.user.user !== '' && loginState.user.password !== '') {
        try {
          if (loginState.remember) {
            localStorage.setItem('userad',loginState.user.user);
          } else {
            localStorage.removeItem('userad');
          }
          dispatch(login({
            user: { ...loginState.user },
          }));
        } catch (err) {
          loginState.user.password = '';
          setLoginState({
            ...loginState,
          });
        } finally {
          if (!loginState.remember) {
            loginState.user.user = '';
          }
          loginState.user.password = '';
        }
      }
    }
  };

  return {
    loginState,
    setLoginState,
    triggerLogin,
  };
};

const setEmptyFieldStyles = (user) => {
  const emptyField = {
    user: {
      class: '',
      childStyle: {},
    },
    password: {
      class: '',
      childStyle: {},
    },
  };
  if (user.user === '') {
    emptyField.user = {
      class: 'animate__animated animate__shakeX animate__fast',
      childStyle: { backgroundColor: '#f1f1f1' },
    };
  }
  if (user.password === '') {
    emptyField.password = {
      class: 'animate__animated animate__shakeX animate__fast',
      childStyle: { backgroundColor: '#f1f1f1' },
    };
  }

  return emptyField;
};
